import type { CSSProperties } from 'react';
import styles from './YeneShopLogo.module.css';

export function YeneShopLogo({ variant = 'wordmark', size = 36, className = '' }: {
  variant?: 'wordmark' | 'mark'; size?: number; className?: string;
}) {
  return <span className={`${styles.logo} ${className}`} role="img" aria-label="Yene Shop" style={{ '--logo-size': `${size}px` } as CSSProperties}>
    <img className={styles.mark} src="/brand/yene-shop-mark.webp" width={size} height={size} alt="" aria-hidden="true" />
    {variant === 'wordmark' && <span className={styles.label} aria-hidden="true">Yene Shop</span>}
  </span>;
}
